import { render, staticRenderFns } from "./BotaoInteligenciaTerritorial.vue?vue&type=template&id=11b8a326&lang=pug"
import script from "./BotaoInteligenciaTerritorial.vue?vue&type=script&lang=js"
export * from "./BotaoInteligenciaTerritorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports